import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const CouponNameInfoSchema = z
  .object({
    type: z.enum(['FOLLOWER', 'NICKNAME', 'BRAND']),
    templateLabel: z.string(),
    personalizedLabel: z.string(),
  })
  .describe('CouponNameInfoSchema');

const GetProposalRequestSchema = z
  .object({
    campaignProposalId: z.number(),
  })
  .describe('GetProposalRequestSchema');

export type GetProposalRequest = z.infer<typeof GetProposalRequestSchema>;

const GetProposalResponseDataSchema = z
  .object({
    campaignProposalId: z.number(),
    brandImageUrl: z.string(),
    brandId: z.string(),
    brandName: z.string(),
    progressStatus: z.string(),
    proposalDate: z.string(),
    goodsCount: z.number(),
    salesRate: z.number(),
    couponQuantityLimit: z.number(),
    period: z.string(),
    couponNameInfos: z.array(CouponNameInfoSchema),
    isProposalActionVisible: z.boolean(),
  })
  .describe('GetProposalResponseDataSchema');

const GetProposalResponseSchema = createApiResponseSchema(GetProposalResponseDataSchema);

export type GetProposalResponse = z.infer<typeof GetProposalResponseSchema>;

export const getProposal = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetProposalRequestSchema),
    async (params: GetProposalRequest): Promise<GetProposalResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetProposalResponse>(
          urlJoin(campaignsApiPath.getProposal(params.campaignProposalId)),
        );
        return response;
      }),
    validateApiResponse(GetProposalResponseSchema),
  ),
);
